import type { Workspace } from './Workspaces';

export type BatchArgs<S = undefined> = {
  enrich?: boolean;
  mineOnly?: boolean;
  sort?: S;
  limit?: number;
  query?: string;
  nextBatchCursor?: string | null;
  method?: string;
};

export interface BatchResponse<T> {
  items: T[];
  metadata: {
    nextCursor: string;
    numResults: number;
    totalItems: number;
  };
}

export interface Base64Response<T> {
  baseObject: T;
  value: string;
}

export type Entity =
  | 'demo'
  | 'presentation'
  | 'tour'
  | 'record'
  | 'overlay'
  | 'playbook';

export type EndpointOptions = {
  preventInvalidate?: boolean;
};

export const CreatorFilters = ['mineOnly', 'all'] as const;
export type CreatorFilter = (typeof CreatorFilters)[number];
export const isCreatorFilter = (filter: any): filter is CreatorFilter =>
  CreatorFilters.includes(filter);

export const Sorts = ['alphabet', 'last_updated'] as const;
export type Sort = (typeof Sorts)[number];
export const isSort = (sort: any): sort is Sort => Sorts.includes(sort);

export const RecordingTypeFilters = [
  'dynamic_recording',
  'live_demo',
  'native_recording',
  'all',
] as const;
export type RecordingTypeFilter = (typeof RecordingTypeFilters)[number];
export const isRecordingTypeFilter = (
  filter: any
): filter is RecordingTypeFilter => RecordingTypeFilters.includes(filter);

export type TypeFilter = Entity | 'all';
export type WorkspaceFilter = Workspace['id'] | 'all';
